import { SUPPORTED_LANGUAGES } from "../../Constant/languages";

/**
 * Ensure to have a language slug
 * Exemple: /fr/mon-slug, /en/mon-slug
 */
export const ensureCleanLocalePrefix = (
  pathname: string,
): string => {
  // Sépare le chemin des paramètres de requête
  const [path, queryString] = pathname.split('?');
  
  // Découpe le chemin en segments (filtre les segments vides)
  const parts = path.split('/').filter(Boolean);

  // Retire tous les slugs de langue partout dans le chemin
  const cleanParts = parts.filter(part => !SUPPORTED_LANGUAGES.includes(part as any));

  // Reconstruit l'URL sans aucun slug de langue
  let result = '/';
  if (cleanParts.length > 0) {
    result += cleanParts.join('/');
  }
  
  // Rajoute les paramètres de requête s'ils existent
  if (queryString) {
    result += `?${queryString}`;
  }
  
  return result;
};